function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  align-self: ", ";\n\n  &.slide-enter, &.slide-appear {\n    transform: translate(0, -50px);\n  }\n  &.slide-enter-active, &.slide-appear-active {\n    transform: none;\n    transition: transform 350ms;\n  }\n  &.slide-exit {\n    transform: none;\n  }\n  &.slide-exit-active {\n    transform: translate(0, -50px);\n    transition: transform 350ms;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  body {\n    overflow: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled, { createGlobalStyle } from 'styled-components';
import { CSSTransition } from 'react-transition-group';
import useResizeObserver from 'use-resize-observer/polyfilled';
import FocusTrap from 'focus-trap-react';
import GridWrapper from '../Grid/GridWrapper';
import GridRow from '../Grid/GridRow';
import GridColumn from '../Grid/GridColumn';
import ModalBackdrop from './ModalBackdrop';
var GlobalStyle = createGlobalStyle(_templateObject(), function (_ref) {
  var bodyOverflowHidden = _ref.bodyOverflowHidden;
  return bodyOverflowHidden ? 'hidden' : undefined;
});
var Dialog = styled.div(_templateObject2(), function (_ref2) {
  var center = _ref2.center;
  return center ? 'center' : undefined;
});

function ModalDialog(_ref3) {
  var id = _ref3.id,
      displayed = _ref3.displayed,
      onBackdropClick = _ref3.onBackdropClick,
      children = _ref3.children;

  var _useState = useState(displayed),
      bodyOverflowHidden = _useState[0],
      setBodyOverflowHidden = _useState[1];

  if (displayed && !bodyOverflowHidden) {
    setBodyOverflowHidden(true);
  } else if (!displayed && bodyOverflowHidden) {
    setTimeout(function () {
      setBodyOverflowHidden(false);
    }, 300);
  }

  var wrapperRef = useRef();

  var _useResizeObserver = useResizeObserver({
    ref: !displayed ? null : wrapperRef
  }),
      wrapperHeight = _useResizeObserver.height;

  var _useState2 = useState(),
      center = _useState2[0],
      setCenter = _useState2[1];

  var handleResize = function handleResize() {
    if (wrapperRef.current === undefined || wrapperRef.current === null) {
      return;
    }

    var _wrapperRef$current$g = wrapperRef.current.getBoundingClientRect(),
        height = _wrapperRef$current$g.height;

    setCenter(height < window.innerHeight);
  };

  useEffect(function () {
    handleResize();
  }, [wrapperHeight]);
  useEffect(function () {
    window.addEventListener('resize', handleResize);
    handleResize();
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, [children]);

  if (onBackdropClick !== undefined) {
    var onDocumentClick = function onDocumentClick(e) {
      if (wrapperRef.current === undefined || wrapperRef.current === null) {
        return;
      }

      var dialogContent = wrapperRef.current.firstChild.firstChild.firstChild;

      var _dialogContent$getBou = dialogContent.getBoundingClientRect(),
          top = _dialogContent$getBou.top,
          right = _dialogContent$getBou.right,
          bottom = _dialogContent$getBou.bottom,
          left = _dialogContent$getBou.left;

      if (e.target.type === 'button' && dialogContent.contains(e.target)) {
        return;
      }

      if (e.clientX < left || e.clientX >= right || e.clientY < top || e.clientY >= bottom) {
        onBackdropClick();
      }
    };

    var onKeyUp = function onKeyUp(e) {
      if (e.keyCode === 27) {
        onBackdropClick();
      }
    };

    useEffect(function () {
      if (displayed) {
        document.addEventListener('click', onDocumentClick);
        document.addEventListener('keyup', onKeyUp);
        return function () {
          document.removeEventListener('click', onDocumentClick);
          document.removeEventListener('keyup', onKeyUp);
        };
      }

      return undefined;
    }, [displayed]);
  }

  return /*#__PURE__*/React.createElement(ModalBackdrop, {
    displayed: displayed
  }, /*#__PURE__*/React.createElement(CSSTransition, {
    "in": displayed,
    timeout: 350,
    classNames: "slide",
    unmountOnExit: true,
    appear: true
  }, /*#__PURE__*/React.createElement(FocusTrap, {
    focusTrapOptions: {
      allowOutsideClick: true,
      escapeDeactivates: false
    }
  }, /*#__PURE__*/React.createElement(Dialog, {
    center: center
  }, /*#__PURE__*/React.createElement(GlobalStyle, {
    bodyOverflowHidden: bodyOverflowHidden
  }), /*#__PURE__*/React.createElement(GridWrapper, {
    pt: {
      xs: 0,
      m: 2
    },
    pb: {
      xs: 0,
      m: 2
    },
    ref: wrapperRef
  }, /*#__PURE__*/React.createElement(GridRow, null, /*#__PURE__*/React.createElement(GridColumn, {
    size: {
      xs: 1,
      m: 10 / 12,
      xl: 8 / 12
    },
    offset: {
      xs: 0,
      m: 1 / 12,
      xl: 2 / 12
    },
    pl: {
      xs: 0,
      s: 0,
      m: 1
    },
    pr: {
      xs: 0,
      s: 0,
      m: 1
    },
    role: "dialog",
    "aria-modal": "true",
    "aria-labelledby": id + "-title",
    "aria-describedby": id + "-desc"
  }, children)))))));
}

ModalDialog.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  displayed: PropTypes.bool.isRequired,
  onBackdropClick: PropTypes.func
} : {};
ModalDialog.defaultProps = {
  onBackdropClick: undefined
};
export default ModalDialog;